// src/pages/admin/SupportPage.jsx
import React, { useState } from 'react';
import SupportTicketsTab from '../../../component/admin/support/SupportTicketsTab';
import ProductReviewsTab from '../../../component/admin/support/ProductReviewsTab';
import NewsletterTab from '../../../component/admin/support/NewsletterTab';
import AdminLayout from '../layout';

const SupportPage = () => {
  const [activeTab, setActiveTab] = useState('tickets');

  const tabs = [
    { id: 'tickets', label: 'Support Tickets' },
    { id: 'reviews', label: 'Product Reviews' },
    { id: 'newsletter', label: 'Newsletter' }
  ];

  return (
    <AdminLayout>
      <div className="px-3 sm:px-4 md:px-6 py-3 sm:py-4">
        <div className="mb-4 sm:mb-6">
          <h1 className="text-xl sm:text-2xl font-semibold text-[#0E1628]">
            Support
          </h1>
          <p className="text-xs sm:text-sm text-[#6B635D] mt-1">
            Manage customer support tickets, product reviews, and newsletter subscribers
          </p>
        </div>

        <div className="border-b border-[#DBDBDB] mb-4 sm:mb-6">
          <div className="flex gap-4 sm:gap-6 overflow-x-auto pb-0.5">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`pb-2 sm:pb-3 px-1 text-sm font-medium transition-colors relative whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'text-[#C49660] border-b-2 border-[#C49660]'
                    : 'text-[#6B635D] hover:text-[#0E1628]'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-3 sm:mt-4">
          {activeTab === 'tickets' && <SupportTicketsTab />}
          {activeTab === 'reviews' && <ProductReviewsTab />}
          {activeTab === 'newsletter' && <NewsletterTab />}
        </div>
      </div>
    </AdminLayout>
  );
};

export default SupportPage;